module.exports = __webpack_public_path__ + "img/sw.edcb8940.png";